import { useFlag } from '@unleash/proxy-client-react'
import { useBoxOrderingModel } from '../../../../../../hooks/useBoxOrderingModel'
import { OrderSummaryMeal } from '../OrderSummaryMeal/OrderSummaryMeal'
import './OrderSummaryMeals.scss'
import tracking from 'src/shared/tracking'
import { FF_USE_BOM_MULTIPLE_PRICES } from 'src/constants/feature-flags'

export const OrderSummaryMeals = ({ meals, addons, onEditItems }) => {
  const useBOMMultiplePrices = useFlag(FF_USE_BOM_MULTIPLE_PRICES)
  const { isBOM, currentBox } = useBoxOrderingModel()
  const totalMeals = meals.reduce(
    (prev, curr) => prev + (curr.quantity || curr.qty),
    0
  )

  const onEditItemsClick = () => {
    tracking.track('CTA Button Clicked', {
      cta_text: 'Edit items'
    })
    onEditItems()
  }

  const totalAddons =
    addons?.reduce((prev, curr) => prev + (curr.quantity || curr.qty), 0) || 0
  return (
    <div className="order-summary-meals">
      <div className="order-summary-meals-header">
        <span className="product-category"> {`${totalMeals} Meals`} </span>
        {onEditItems && (
          <span className="edit-item-link" onClick={onEditItemsClick}>
            Edit items
          </span>
        )}
      </div>
      <div className="order-summary-meals-list">
        {meals.map(meal => (
          <OrderSummaryMeal
            meal={meal}
            isBOM={isBOM}
            key={meal.mealName}
            currentBox={currentBox}
            useBOMMultiplePrices={useBOMMultiplePrices}
          />
        ))}
      </div>
      {addons?.length > 0 && (
        <>
          <div className="order-summary-meals-header">
            <span className="product-category">{`${totalAddons} Add Ons`}</span>
          </div>
          <div className="order-summary-meals-list">
            {addons.map(meal => (
              <OrderSummaryMeal
                meal={meal}
                isBOM={isBOM}
                key={meal.mealName}
                currentBox={currentBox}
                useBOMMultiplePrices={useBOMMultiplePrices}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
